import { HttpClient } from "@forgerock/javascript-sdk";

export default async function apiRequest(url, method, body) {
  let json;

  const response = await HttpClient.request({
    timeout: 100000,
    url: url,
    init: {
      body: body && JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
      method,
    },
  });
  if (!response.ok) {
    json = {
      error: true,
      message: response.statusText,
      status: response.status,
    };
    if (response.status === 401) {
      window.location.pathname = "/";
    }
  } else {
    json = await response.json();
  }

  return json;
}
